// extracted by mini-css-extract-plugin
export default {"themeBox":"ThemeBox_themeBox__PBg7V","toggle":"ThemeBox_toggle__bBhMm","darkMode":"ThemeBox_darkMode__1AjGP"};